import * as Icons from "@nova/component-icons"
import { InputOutlined } from "@nova/ds-component-input"
import { useRef } from "react"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { ActivityChartSection } from "./ActivityChartSection"
import { ActivityStatTiles } from "./ActivityStatTiles"
import { ActivityTimeline } from "./ActivityTimeline"
import { ActiveFilterPills } from "./filters/ActiveFilterPills"
import { ActivityFilterMenu, ActivityFilterMenuRef } from "./filters/ActivityFilterMenu"
import { selectActivitySearch, setSearch } from "./slice"
import { useActivityChart } from "./useActivityData"

const ActivitySearchInput = () => {
    const dispatch = useAppDispatch()
    const search = useAppSelector(selectActivitySearch)

    return (
        <InputOutlined
            value={search}
            onChange={(e) => dispatch(setSearch(e.currentTarget.value))}
            placeholder="Search"
            leftItem={<Icons.Icon Icon={Icons.MagnifyingGlass} className="mr-1" />}
            className="w-[260px]"
        />
    )
}

export const ActivityPage = () => {
    const { series, totals, unit, isLoading } = useActivityChart()
    const filterMenuRef = useRef<ActivityFilterMenuRef>(null)

    return (
        <div className="flex flex-col gap-6 pt-1 pb-10 max-w-[848px] m-auto">
            <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                    <ActivityFilterMenu ref={filterMenuRef} />
                    <ActiveFilterPills menuRef={filterMenuRef} />
                </div>
                <ActivitySearchInput />
            </div>

            <ActivityStatTiles totals={totals} isLoading={isLoading} />
            <ActivityChartSection series={series} unit={unit} isLoading={isLoading} />
            <div className="max-w-[500px] m-auto w-full">
                <ActivityTimeline />
            </div>
        </div>
    )
}
